module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('entity-page', {
    attrs: {
      "id": "page__printer",
      "loading": _vm.progress
    }
  }, [_c('template', {
    slot: "header-right"
  }, [_c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'xmark'],
      "danger-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('z-icon-button', {
    attrs: {
      "icon": ['fa', 'check'],
      "success-light": "",
      "rounded": ""
    },
    on: {
      "click": _vm.save
    }
  })], 1), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    attrs: {
      "id": "name",
      "name": "name",
      "label": "Название",
      "error": _vm.errors.first('name'),
      "data-vv-name": "name",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.printer.name),
      callback: function($$v) {
        _vm.$set(_vm.printer, "name", $$v)
      },
      expression: "printer.name"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        min: 4,
        max: 20,
        regex: _vm.ipValidate
      }),
      expression: "{required: true, min: 4, max: 20, regex: ipValidate}"
    }],
    attrs: {
      "id": "ip",
      "name": "ip",
      "label": "IP",
      "error": _vm.errors.first('ip'),
      "data-vv-name": "ip",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.printer.ip),
      callback: function($$v) {
        _vm.$set(_vm.printer, "ip", $$v)
      },
      expression: "printer.ip"
    }
  }), _vm._v(" "), _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    attrs: {
      "id": "port",
      "name": "port",
      "label": "Порт",
      "error": _vm.errors.first('port'),
      "data-vv-name": "port",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.printer.port),
      callback: function($$v) {
        _vm.$set(_vm.printer, "port", $$v)
      },
      expression: "printer.port"
    }
  }), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "id": "stock_id",
      "name": "stock_id",
      "label": "Склад",
      "error": _vm.errors.first('stock_id'),
      "data-vv-name": "stock_id",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.printer.stock_id),
      callback: function($$v) {
        _vm.$set(_vm.printer, "stock_id", $$v)
      },
      expression: "printer.stock_id"
    }
  }, _vm._l((_vm.stocks), function(stock) {
    return _c('option', {
      key: stock.id,
      domProps: {
        "value": stock.id
      }
    }, [_vm._v(_vm._s(stock.name))])
  })), _vm._v(" "), _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "id": "status_id",
      "name": "status_id",
      "label": "Статус",
      "error": _vm.errors.first('status_id'),
      "data-vv-name": "status_id",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.printer.status_id),
      callback: function($$v) {
        _vm.$set(_vm.printer, "status_id", $$v)
      },
      expression: "printer.status_id"
    }
  }, [_c('option', {
    key: 1,
    domProps: {
      "value": 1
    }
  }, [_vm._v("Не установлен")]), _vm._v(" "), _c('option', {
    key: 2,
    domProps: {
      "value": 2
    }
  }, [_vm._v("Онлайн")]), _vm._v(" "), _c('option', {
    key: 3,
    domProps: {
      "value": 3
    }
  }, [_vm._v("Отключен")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48397061","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/stock/views/Printer.vue
// module id = 1127
// module chunks = 0